import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import FlyerMaricopa from "@/pages/FlyerMaricopa";
import SeoPage from "@/pages/SeoPage";
import WeddingDressPage from "@/pages/WeddingDressPage";
import UpdateCard from "@/pages/UpdateCard";
import ThankYou from "@/pages/ThankYou";
import Welcome from "@/pages/Welcome";
import FlyerWelcome from "@/pages/FlyerWelcome";
import { SEO_PAGES } from "@/lib/site";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          {SEO_PAGES.filter((p) => p.kind === "city").map((p) => (
            <Route key={p.path} path={p.path} element={<SeoPage page={p} />} />
          ))}
          <Route path="/wedding-dress-cleaning-preservation" element={<WeddingDressPage />} />
          <Route path="/print/maricopa" element={<FlyerMaricopa />} />
          <Route path="/print/welcome" element={<FlyerWelcome />} />
          <Route path="/update-card/:token" element={<UpdateCard />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
